export const LOADING = 'GENERAL_LOADING';
export const GENERAL_SHOW_MESSAGE = 'GENERAL_SHOW_MESSAGE';
export const GET_DOCUMENT_TYPE = 'GET_DOCUMENT_TYPE';
export const GET_PARAMETER_COMBO = 'GET_PARAMETER_COMBO';
export const GET_ASSISTANT_ADDRESS = 'GET_ASSISTANT_ADDRESS';
export const GET_STATES_LIST = 'GET_STATES_LIST';
export const SET_PURCHASE_PARAMETERS = 'GENERAL_SET_PURCHASE_PARAMETERS';
export const SET_REJECT_TYPES = 'SET_REJECT_TYPES';
export const SET_APP_NAME = 'GENERAL_SET_APP_NAME';
export const SET_SERVICE_TYPES = 'SET_SERVICE_TYPES';
export const GET_FEATURE_TYPES = 'GET_FEATURE_TYPES';
export const SET_VALUE_TAB = 'SET_VALUE_TAB';
export const GENERAL_SET_FILTERS_PAGE = 'GENERAL_SET_FILTERS_PAGE';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_PARAMETER_APP = 'SET_PARAMETER_APP';
export const SET_TENANT = 'SET_TENANT';
export const SET_STATES_AND_CITIES = 'SET_STATES_AND_CITIES';
export const GET_PARAMETERS_MARKET = 'GET_PARAMETERS_MARKET';
export const SET_CUSTOMER_PARAMETERS = 'SET_CUSTOMER_PARAMETERS';
export const SET_CREATE_CUSTOMER_PARAMETERS = 'SET_CREATE_CUSTOMER_PARAMETERS';
export const SET_CREATE_COUNTRIES_LIST = 'SET_CREATE_COUNTRIES_LIST';
